import { put, takeLatest, select, cancel, take } from 'redux-saga/effects';
import get from 'lodash/get';

import {
  CALENDAR_APPOINTMENT_GUARD,
  calendarAppointmentGuardActions,
} from '../appointmentGuard';
import {
  selectScheduleLocations,
  selectSchedulePopoverData,
  selectScheduleTargerProviderId,
} from '../selectors';
import { actions as servicesActions } from '../requests/provider-services-req';

function* handleAppointmentGuard() {
  const id = yield select(selectScheduleTargerProviderId);
  const locations = yield select(selectScheduleLocations);
  const schedule = yield select(selectSchedulePopoverData);
  const locationId = get(schedule, 'location.id');
  const serviceId = get(schedule, 'service.id');

  const hasLocation = locations.some(location => locationId === location.id);

  if (!hasLocation) {
    yield put(calendarAppointmentGuardActions.finish(false));
    yield cancel();
  }

  yield put(servicesActions.send({ id, locationId }));
  const { payload: services } = yield take(servicesActions.succeed);

  const hasService = services.some(service => serviceId === service.id);
  yield put(calendarAppointmentGuardActions.finish(hasService));
}

export default function* appointmentGuardSaga() {
  yield takeLatest([CALENDAR_APPOINTMENT_GUARD.START], handleAppointmentGuard);
}



// WEBPACK FOOTER //
// ./src/redux/schedule/sagas/appointment-guard-saga.js